let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9fb63")).then(() => parcelRequire('dhNEi'));